import _ from 'lodash'
import { CommonState, Model } from '@/core/classes/Model'

export type Channel = {
  _id: string
  name: string
  fname: string
  t: string
  msgs: Number
  usersCount: Number
  u: {
    _id: string
    username: string
  }
  customFields: {}
  ts: Date
  ro: false
  default: false
  sysMes: true
  _updatedAt: Date
}

export type RocketChatState = CommonState & {
  channels: {
    byConsultation: Record<string, string>
    byEstablishment: Record<string, string>
  }
  directMessages: {
    byStaff: Record<string, string>
  },
  groups: {
    byConsultation: Record<string, string>
    byEstablishment: Record<string, string>
  }
}

class RocketChatModel extends Model {
  static instance: RocketChatModel

  static getInstance() {
    if (!RocketChatModel.instance) {
      RocketChatModel.instance = new RocketChatModel('rocketChat')
    }
    return RocketChatModel.instance
  }

  getInitialState(): RocketChatState {
    return _.merge({}, this.commonState, {
      channels: {
        byConsultation: {},
        byEstablishment: {},
      },
      directMessages: {
        byStaff: {}
      },
      groups: {
        byConsultation: {},
        byEstablishment: {},
      },
    })
  }

  createChannel = async (channelName: string, isEmbeddedLayout: boolean = true) => {
    return await this.httpClient.request('/rocketchat/channel', 'POST', { channelName, isEmbeddedLayout })
  }

  createDirectMessage = async (username: string, isEmbeddedLayout: boolean = true): Promise<string> => {
    return await this.httpClient.request<string>('/rocketchat/direct', 'POST', { username, isEmbeddedLayout })
  }

  createGroup = async (groupName: string, members: string[], isEmbeddedLayout: boolean = true) => {
    return await this.httpClient.request('/rocketchat/group', 'POST', { groupName, members, isEmbeddedLayout })
  }

  getGroup = async (query: { groupId: string } | { groupName: string }, isEmbeddedLayout: boolean = true): Promise<string> => {
    if ('groupId' in query) {
      return await this.httpClient.request<string>(`/rocketchat/group/${query.groupId}`, 'GET', { isEmbeddedLayout })
    }
    if ('groupName' in query) {
      return await this.httpClient.request<string>('/rocketchat/group', 'GET', { groupName: query.groupName, isEmbeddedLayout })
    }
    throw new Error('Missing groupId or groupName in query of rocketChatModel getGroup')
  }

  login = async () => {
    const { loginToken } = await this.httpClient.request<{ loginToken: string }>('/rocketchat/login', 'POST')
    return loginToken
  }
}

export default RocketChatModel.getInstance()
